import companies from './companies'
import brands from './brands'
import delegations from './delegations'
import assignations from './assignations'
import assignationsUsers from './assignationsUsers'
import operators from './operators'
import configurations from './configurations'
import commissions from './commissions'
import credentials from './credentials'
import plans from './plans'
import channels from './channels'

export default {
  companies,
  brands,
  delegations,
  assignations,
  assignationsUsers,
  operators,
  commissions,
  configurations,
  credentials,
  plans,
  channels
}
